import React from 'react';
import { FormControl, FormLabel, RadioGroup as MuiRadioGroup, FormControlLabel, Radio, FormHelperText, RadioGroupProps } from '@mui/material';


type Props = Omit<RadioGroupProps, 'error'> & {
    error?: string,
    readOnly?: boolean,
    label: string,
    items: {id: any, title: string}[]
}
  
export default function RadioGroup({ error, ...other }: Props) { 
    return (
        <FormControl error={!!error}>
            <FormLabel>{other.label}</FormLabel>
            <MuiRadioGroup {...other}
            >
                {
                    other.items.map(
                        item => (
                            <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.title} />
                        )
                    )
                }
            </MuiRadioGroup>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
}
